module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_6_3.9c7d3147.png";